import React, { Component } from 'react';
import { Modal, Steps, Button, message, Select } from 'antd';
const Step = Steps.Step;
const Option = Select.Option;

class StepModal extends Component {
  constructor(props) {
    super(props);
    this.state = {step: 0, stepLimit: 0, validation: false, newStep: {}};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handleStepNumber = this.handleStepNumber.bind(this);
    this.handleProfile = this.handleProfile.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  handleNext() {
    if(!this.state.validation)
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.newStep);
      this.setState({validation: true, newStep: {}});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  handleStepNumber(event) {
    this.setProp('step_number', event.target.value);
    this.setState({validation: true});
  }

  handleProfile(value) {
    this.setProp('profile_id', value);
    this.setState({validation: true});
  }

  setProp(prop, value) {
    const record = this.state.newStep;
    record[prop] = value;

    this.setState({newStep: record});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // List profiles
    const profiles = this.props.profiles.map(profile => {
      return (
        <Option value={profile.id} key={profile.id}>{profile.names}</Option>
      );
    });
    // Render component
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Quién autoriza" />
            <Step title="Finalizar" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Número de paso</label>
              <input type="number" className="form-control" defaultValue={this.props.current.step_number} onChange={this.handleStepNumber} />
            </div>

            <div className="form-group">
              <label>Persona que autoriza</label>
              <Select style={{ width: '100%' }} onChange={this.handleProfile}>
                {profiles}
              </Select>
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default StepModal;



// WEBPACK FOOTER //
// ./src/components/modals/StepModal.js